export default "__VITE_ASSET__138231d6__"